import { Check } from '@mui/icons-material'
import styles from './PlanPreviewCard.module.css';

interface PlanPreviewCardProps {
	name: string;
	advantages: string[];
}

export const PlanPreviewCard = ({ name, advantages }: PlanPreviewCardProps) => {
	const filtered = advantages.filter((a) => a.trim());

	return (
		<div className={styles.wrapper}>
			<div className={styles.card}>
				<div className={styles.header}>
					<h3 className={styles.planName}>{name || 'Nome do Plano'}</h3>
				</div>
				<ul className={styles.advantagesList}>
					{filtered.length > 0 ? (
						filtered.map((adv, i) => (
							<li key={i} className={styles.advantageItem}>
								<span className={styles.checkBadge} aria-hidden="true">
									<Check className={styles.checkIcon} />
								</span>
								<span className={styles.advantageText}>{adv}</span>
							</li>
						))
					) : (
						<li className={styles.advantageItem}>
							<span className={styles.checkBadge} aria-hidden="true">
								<Check className={styles.checkIcon} />
							</span>
							<span className={styles.advantageText}>Vantagens do plano</span>
						</li>
					)}
				</ul>
				<button className={styles.ctaButton} type="button">
					Solicitar demonstração
				</button>
			</div>
			<span className={styles.badge}>
				<span className={styles.badgeDot}>&#9679;</span>
				Renderizado
			</span>
		</div>
	);
};
